export const DEGREE = [
    {label: 'MBBS/BDS', value: '1'},
    {label: 'Health Sciences & Professional Courses', value: '2'},
    {label: 'Both', value: '3'}
]
export const COACHING_PREFER = [
    {label: 'yes', value: 1},
    {label: 'No', value: 0},
]

export const PREFERED_LOCATION = [
    {label: 'Only my Home state', value: '1'},
    {label: 'Open to PAN India, including home state and Nearby states', value: '2'},
    {label: 'Open to Study Abroad', value: '3'},
    
]

export const PREFERED_COLLEGE = [
    {
        label: 'Government Colleges/Central Universities',
        value: '101', fee: '25 Lacks', 
        cutoff: [
            {rank: '1-10', gn: '1-10', obc: '1-10', sc:'1-10', st:'1-10'},
            {rank: '1-10', gn: '1-10', obc: '1-10', sc:'1-10', st:'1-10'},
            {rank: '1-10', gn: '1-10', obc: '1-10', sc:'1-10', st:'1-10'}
        ]
    },
    {
        label: 'Private Colleges',
        value: '102',
        fee: '15 Lacks',
        cutoff: [
            {rank: '1-10', gn: '1-10', obc: '1-10', sc:'1-10', st:'1-10'},
            {rank: '1-10', gn: '1-10', obc: '1-10', sc:'1-10', st:'1-10'},
            {rank: '1-10', gn: '1-10', obc: '1-10', sc:'1-10', st:'1-10'}
        ]
    },
    {
        label: 'Deemed Universities', 
        value: '103', 
        fee: '22 Lacks', 
        cutoff: [
            {rank: '1-10', gn: '1-10', obc: '1-10', sc:'1-10', st:'1-10'},
            {rank: '1-10', gn: '1-10', obc: '1-10', sc:'1-10', st:'1-10'},
            {rank: '1-10', gn: '1-10', obc: '1-10', sc:'1-10', st:'1-10'}
        ]
    }
]

export const FREE_COUNSELLING = [
    {label: 'Yes', value: 533711, id:'1'},
    {label: 'No', value: 533711, id:'0'},
]
export const ONE_TO_ONE_COUNSELLING = [
    {label: 'Yes', value: 119929, id:'1'},
    {label: 'No', value: 119929, id:'0'},
]
export const ENROLLING_PRODUCT = [
    {label: 'Yes', value: 533710, id:1},
    {label: 'No', value: 533710, id:0},
]

